<template>
  <div>
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
      width="80%"
      clearable
    >
    </v-select>
  </div>
</template>

<script>
import { saleUtil } from '@/util'
import { saleStatusHistory } from '@/config'

export default {
  components: {
    //
  },
  props: {
    value: {},
    type: Number,
    height: { default: '32px' }
  },
  data: () => ({
    items: []
    // test: {}
  }),
  created() {
    const status = saleStatusHistory.STATUS_HISTORY_TYPE_ID
    const statusUtil = saleUtil

    let tmp
    if (this.type === status.PAYMENT) {
      tmp = statusUtil.getSalePaymentStatusList()
    } else if (this.type === status.SHIP) {
      tmp = statusUtil.getSaleShipStatusList()
    } else if (this.type === status.COMPLETE) {
      tmp = statusUtil.getSaleCompleteStatusList()
    } else if (this.type === status.STATUS_NOTIFICATION) {
      tmp = statusUtil.getSaleNotificationStatusList()
    }

    this.items = tmp
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('changeValue', newValue)
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
